function NoLinkedContextsCard() {
  return (
    <section className="bg-light text-ui-dark grid gap-6 rounded-sm p-6 shadow-xl">
      <header>
        <h2 className="border-ui border-b pb-2 text-xl font-bold">No linked users available</h2>
      </header>
      <p className="leading-snug">
        There are no links users currently available. Contact an organisation administrator or Noted
        support via the support site or by emailing support@noted.com.
      </p>
    </section>
  );
}

export default NoLinkedContextsCard;
